
<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Academic Audit Reports</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="inner-title"  >
          <h4>Academic Audit Reports</h4>
         
        </div>
      </div>
      <div class="col-md-4 col-lg-3">
        <div class="pdf-box">
            <div class="pdf-icon">
                <span><i class="fa fa-file-pdf-o"></i></span>
            </div>
            <h5>Audit Format For BBA</h5>            
            <a class="button-text" href="https://drive.google.com/file/d/1ZqsMSJ-KwdysjgQKQH0-1uS2gFsBDmZT/view?usp=sharing" target="_blank">Read More</a>
        </div>
      </div>
      <div class="col-md-4 col-lg-3">
        <div class="pdf-box">
            <div class="pdf-icon">
                <span><i class="fa fa-file-pdf-o"></i></span>
            </div>
            <h5>Audit Format For BCCA</h5>            
            <a class="button-text" href="https://drive.google.com/file/d/1OwrmarlhqAu93b4d9tGJ3sETiYz-fAK-/view?usp=sharing" target="_blank">Read More</a>
        </div>
      </div>
    </div>
  </div>
</section>
